import { Button, Form, Icon, Input } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import UserEndpoint from '../../core-module/models/LoopBack/Models/UserEndpoint';
import { setLogin } from '../../core-module/redux/Auth/actions';

interface LoginFormProps extends FormComponentProps {
  dispatch: Dispatch;
  onModeChange: (value: string) => void;
}

interface State {
  loading: boolean;
}

class LoginForm extends React.Component<LoginFormProps, State> {

  loopBackEndpoint: UserEndpoint;

  constructor(props) {
    super(props);
    this.loopBackEndpoint = new UserEndpoint();
    this.state = {
      loading: false
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.setState({loading: true});
      this.props.dispatch(setLogin(values));
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className="login-form" onSubmit={this.handleSubmit}>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Voer een geldige email in' }],
          })(
            <Input
              type={'email'}
              size={'large'}
              placeholder={'Email'}
              prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Voer een geldig wachtwoord in' }],
          })(
            <Input
              type={'password'}
              size={'large'}
              placeholder={'Wachtwoord'}
              prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            htmlType={'submit'} type={'primary'}
            className="login-form-button"
          >
            {this.state.loading &&
              <Icon type="loading" style={{fontSize: 24, color: 'white'}} spin/>
            }
            Log in
          </Button>
          <Button
            style={{marginLeft: 5}}
            htmlType={'button'}
            className="login-form-button"
            onClick={() => this.props.onModeChange('reset-request')}
          >
            Wachtwoord vergeten
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const DecoratedForm = Form.create()(LoginForm);

export default connect<any, any, any>(null, null)(DecoratedForm);
